// Pure formatting for the event screen (S3).
import { APP_MIN_AGE } from '@spot/shared';
import type { TFunction } from 'i18next';

/** «2 год», «45 хв», «1 год 30 хв». */
export function formatDuration(startAt: Date, endAt: Date, t: TFunction): string {
	const minutes = Math.max(0, Math.round((endAt.getTime() - startAt.getTime()) / 60_000));
	const hours = Math.floor(minutes / 60);
	const rest = minutes % 60;
	if (hours === 0) return t('event.duration_m', { m: rest });
	if (rest === 0) return t('event.duration_h', { h: hours });
	return t('event.duration_hm', { h: hours, m: rest });
}

/** Date chip, e.g. «сб, 18 жовтня», in the city timezone. */
export function formatDate(date: Date, timeZone: string, locale: string): string {
	return new Intl.DateTimeFormat(locale, {
		timeZone,
		weekday: 'short',
		day: 'numeric',
		month: 'long',
	}).format(date);
}

export function formatTime(date: Date, timeZone: string, locale: string): string {
	return new Intl.DateTimeFormat(locale, {
		timeZone,
		hour: '2-digit',
		minute: '2-digit',
		hourCycle: 'h23',
	}).format(date);
}

/** Age chip (D44): «14–17» for teens-only events, «16+» / «18+» for a minimum; null = none. */
export function ageChip(minAge: number | null, maxAge: number | null): string | null {
	if (maxAge !== null) return `${String(minAge ?? APP_MIN_AGE)}–${String(maxAge)}`;
	return minAge === null ? null : `${String(minAge)}+`;
}

/**
 * `extra_conditions` is free text; organizers write one condition per line or separate them
 * with «;» or «·» (level, pace, what to bring). Each becomes an info chip.
 */
export function conditionChips(extra: string | null): string[] {
	if (extra === null) return [];
	return extra
		.split(/[\n;·]+/)
		.map((part) => part.trim())
		.filter((part) => part.length > 0)
		.slice(0, 8);
}
